import { ERC721Generic_11_21_22 } from './ERC721Generic_11_21_22'

export const legacy = { ERC721Generic_11_21_22 }
